export default {"src":"/polygon/_next/static/media/partner_9.7dcf0d39.svg","height":121,"width":180};